import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TenancyContext } from '@core/tenancy';
import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { ProbateRotateSegments } from '@app/probate/shared/enums';

@Injectable({ providedIn: 'root' })
export class DashboardNavigationService {
  private readonly _tenancy = inject(TenancyContext);
  private readonly _router = inject(Router);

  public goToDashboard(tenantKey: TenantKey = TenantKey.PROBATE) {
    return this._router.navigate([
      this._tenancy.link(
        tenantKey,
        ProbateRotateSegments.dashboard,
        ProbateRotateSegments.home,
      ),
    ]);
  }
}
